<template>
  <div class="warehouse-page">
    <el-form inline class="bysearchForm" ref="dataForm">
      <div class="searchLine">
        <el-form-item prop="periodId" class="typeInput">
          <el-form-item prop="companyId" class="typeInput" v-if="ListId === 2">
            <el-select
              v-model="dataForm.companyId"
              placeholder="公司"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in companyList"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="orgId" class="typeInput" v-if="ListId === 1">
            <el-select
              v-model="dataForm.orgId"
              placeholder="供应商"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in orgList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-select
            v-model="dataForm.periodId"
            placeholder="时段"
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in periodList"
              :key="index"
              :label="item.withTimeName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="state">
          <el-select
            v-model="dataForm.state"
            placeholder="状态"
            multiple
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in stateList"
              :key="index"
              :label="item.state"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="week" class="typeInput">
          <el-select
            v-model="dataForm.week"
            placeholder="星期"
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in weeksList"
              :key="index"
              :label="item.week"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="typeInput">
          <el-button @click="getDetailList()">查询</el-button>
          <el-button
            v-if="isAuth('tc:goodscompany:save')"
            type="primary"
            size="small"
            @click="updateGoods()"
            :disabled="detailListSelections.length <= 0"
            >批量上架商品</el-button
          >
        </el-form-item>
      </div>
    </el-form>
    <div class="main-container">
      <div class="aside-wrap">
        <el-select
          v-model="ListId"
          @change="getDataList(1)"
          class="sideTopSelect"
        >
          <el-option
            v-for="(item, index) in ListSelections"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-table
          height="calc(100vh - 210px)"
          :data="dataList"
          ref="dataList"
          border
          :row-class-name="tableRowClassName"
          @selection-change="$selectionChange($event, 'dataList')"
          @row-click="$clickRow($event, 'dataList', getDetailList($event))"
          @select="$select(arguments, 'dataList')"
          @select-all="$clearSelection('dataList')"
        >
          <el-table-column
            type="selection"
            header-align="center"
            align="center"
            width="50"
          />
          <el-table-column
            prop="name"
            header-align="center"
            align="center"
            :label="ListName"
          />
        </el-table>
        <el-pagination
          background
          @size-change="$sizeChange($event, 'dataList')"
          @current-change="$currentChange($event, 'dataList')"
          :current-page="dataListIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="dataListSize"
          :total="dataListCount"
          layout="total, sizes, prev, pager, next"
        />
      </div>
      <div class="main-wrap">
        <h5>公司供应商</h5>
        <el-table
          :data="detailList"
          ref="detailList"
          border
          stripe
          v-loading="detailListLoading"
          @row-click="$clickRow($event, 'detailList')"
          @selection-change="$selectionChange($event, 'detailList')"
          style="width: 100%"
        >
          <el-table-column
            type="selection"
            header-align="center"
            align="center"
            width="50"
          >
          </el-table-column>
          <el-table-column
            prop="orgName"
            header-align="center"
            align="center"
            label="供应商名称"
            v-if="ListId === 1"
          >
          </el-table-column>
          <el-table-column
            prop="companyName"
            header-align="center"
            align="center"
            label="公司名称"
            v-if="ListId === 2"
          >
          </el-table-column>
          <el-table-column
            prop="periodWithTimeName"
            header-align="center"
            align="center"
            label="时段"
          >
          </el-table-column>
          <el-table-column
            prop="weeks"
            header-align="center"
            align="center"
            label="星期"
          >
          </el-table-column>

          <el-table-column
            prop="startDate"
            header-align="center"
            align="center"
            label="生效时间"
          >
          </el-table-column>

          <el-table-column
            prop="endDate"
            header-align="center"
            align="center"
            label="终止日期"
          >
          </el-table-column>

          <el-table-column
            prop="createdAt"
            header-align="center"
            align="center"
            label="创建日期"
          >
          </el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            width="220"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button
                v-if="isAuth('tc:orgcompany:info')"
                type="text"
                size="small"
                @click="$dialog('addOrUpdate', scope.row.id, true)"
                >查看详情</el-button
              >
              <el-button
                v-if="isAuth('tc:orgcompany:comInfo')"
                type="text"
                size="small"
                @click="
                  $dialog(
                    'comFreezerUpdate',
                    scope.row.id,
                    true,
                    scope.row.orgId,
                    scope.row.weeks,
                  )
                "
                >仓位分配</el-button
              >
              <el-button
                v-if="isAuth('tc:goodscompany:save')"
                type="text"
                size="small"
                @click="
                  $dialog('goodsOnShelves', scope.row.orgId, scope.row.id + '')
                "
                >上架商品</el-button
              >
              <el-button
                v-if="isAuth('tc:advancesale:save')"
                type="text"
                size="small"
                @click="$dialog('advanceSale', scope.row.id, true)"
                >现售预订</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="$sizeChange($event, 'detailList')"
          @current-change="$currentChange($event, 'detailList')"
          :current-page="detailListIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="detailListSize"
          :total="detailListCount"
          layout="total, sizes, prev, pager, next, jumper"
        />
      </div>
    </div>
    <!-- 弹窗, 查看详情 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @success="getDetailList"
    />
    <!-- 弹窗，上架商品   -->
    <goods-on-shelves
      v-if="goodsOnShelvesVisible"
      ref="goodsOnShelves"
      @success="getDetailList"
    />
    <!-- 弹窗，仓位分配   -->
    <com-freezer-update
      v-if="comFreezerUpdateVisible"
      ref="comFreezerUpdate"
      @success="getDetailList"
    />
    <advance-sale
      v-if="advanceSaleVisible"
      ref="advanceSale"
      @success="getDetailList"
    />
  </div>
</template>

<script>
import { threeListMixin, normal } from '@/mixins';
import AddOrUpdate from './orgcompany-add-or-update';
import GoodsOnShelves from './goods-on-shelves';
import ComFreezerUpdate from './com-freezer-update';
import AdvanceSale from './advance-sale';
export default {
  mixins: [normal, threeListMixin],
  data() {
    return {
      dataForm: {
        companyId: '',
        orgId: '',
        periodId: '',
        isUse: 1,
        state: [0, 1],
        week: '',
      },
      ListId: 1,
      ListName: '',
      companyIdsAndName: [],
      name: [],
      detailList: [],
      periodList: [],
      orgList: [],
      companyList: [],
      dataList: [],
      detailListSelections: [],
      addOrUpdateVisible: false,
      goodsOnShelvesVisible: false,
      advanceSaleVisible: false,
      comFreezerUpdateVisible: false,
      ListSelections: [
        { id: 1, name: '公司列表' },
        { id: 2, name: '供应商列表' },
      ],
      stateList: [
        { id: 0, state: '待生效' },
        { id: 1, state: '生效中' },
        { id: 2, state: '已终止' },
      ],
      weeksList: [
        { id: 1, week: '一' },
        { id: 2, week: '二' },
        { id: 3, week: '三' },
        { id: 4, week: '四' },
        { id: 5, week: '五' },
        { id: 6, week: '六' },
        { id: 7, week: '日' },
      ],
    };
  },
  //注册需要引入的组件，即一个vue页面，这里指employees-add-or-update页面，
  components: {
    GoodsOnShelves,
    //要注册的文件首字母大写
    AddOrUpdate,
    ComFreezerUpdate,
    AdvanceSale,
  },
  activated() {
    this.getDataList();
  },
  created() {
    this.getPeriodList();
    this.getCompanyList();
    this.getOrgList();
  },
  methods: {
    tableRowClassName({ row }) {
      // this.
      if (row.isUse === 0) return 'danger-row';
    },
    // 获取数据列表
    getDataList(type) {
      if (type === 1) {
        this.dataForm.orgId = null;
        this.dataForm.companyId = null;
      }
      if (this.ListId === 1) {
        this.getCompanyPage();
      } else if (this.ListId === 2) {
        this.getOrgPage();
      }
    },
    getCompanyPage() {
      this.$api({
        url: '/tc/company/query',
        params: {
          page: this.dataListIndex,
          limit: this.dataListSize,
        },
        after: (data) => {
          if (data && data.code === 0) {
            this.dataList = data.list.records;
            this.dataListCount = data.list.total;
            this.ListName = this.ListSelections[0].name;
            this.dataForm.companyId = data.list.records[0].id;
            this.getDetailList();
          } else {
            this.dataLit = [];
            this.dataListCount = 0;
          }
        },
      });
    },
    getOrgPage() {
      this.$http({
        url: `/cc/org/page`,
        method: 'get',
        params: {
          type: 0,
          isUse: 1,
          page: this.dataListIndex,
          limit: this.dataListSize,
        },
      }).then(({ data }) => {
        if (data && data.status === 0) {
          this.dataList = data.data.items;
          this.dataListCount = data.data.total;
          this.ListName = this.ListSelections[1].name;
          this.dataForm.orgId = data.data.items[0].id;
          this.getDetailList();
        } else {
          this.dataList = [];
          this.dataListCount = 0;
        }
      });
    },
    getOrgList() {
      this.$http({
        url: `/cc/org/all`,
        method: 'get',
        params: { type: 0, isUse: 1 },
      }).then(({ data }) => {
        if (data && data.status === 0) {
          this.orgList = data.data.items;
        }
      });
    },

    getCompanyList() {
      this.$http({
        url: `/tc/company/combo`,
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.companyList = data.list;
        }
      });
    },
    // 批量上架商品
    updateGoods(id) {
      let ids = id
        ? [id]
        : this.detailListSelections
            .map((item) => {
              return item.id;
            })
            .join(',');
      let firstData = this.detailListSelections[0].orgId;
      let orgId = this.detailListSelections
        .map((item) => {
          return item.orgId;
        })
        .filter((item) => firstData !== item);
      if (orgId?.length) {
        this.$message.error(`请选择相同的供应商进行批量操作`);
      } else {
        this.$dialog('goodsOnShelves', firstData, ids);
      }
    },
    // 获取数据列表
    getDetailList(row) {
      if (this.ListId === 1) {
        this.dataForm.companyId = row ? row.id : this.dataForm.companyId;
      } else if (this.ListId === 2) {
        this.dataForm.orgId = row ? row.id : this.dataForm.orgId;
      }
      this.$api({
        url: '/tc/orgcompany/list',
        params: {
          page: this.detailListIndex,
          limit: this.detailListSize,
          ...this.dataForm,
          state: this.dataForm.state.map((i) => i).join(','),
          // isUse:this.dataForm.isUse,
          // state:this.dataForm.state,
        },
        after: (data) => {
          if (data && data.code === 0) {
            this.detailList = data.page.records;
            this.detailListCount = data.page.total;
          } else {
            this.detailList = [];
            this.detailListCount = 0;
          }
        },
      });
    },
    getPeriodList() {
      this.$http({
        url: `/cc/global-period/all`,
        method: 'get',
        params: { isUse: 1 },
      }).then(({ data }) => {
        if (data && data.status === 0) {
          this.periodList = data.data.items;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.sideTopSelect {
  .el-input__inner {
    text-align: center;
  }
}
</style>
